import React, { useState } from "react";
import Style from "./guideButtons.module.css";
function index({
  slug,
  btnsDetails,
  lang,
}: {
  slug?: string;
  btnsDetails: any;
  lang: any;
}) {
  const [check, setCheck] = useState(0);

  return (
    <div className={Style.btnCon}>
      {btnsDetails?.map((item, index) => (
        <a
          href={item.link_button}
          className={check == index ? Style.btnCheck : Style.btn}
          onClick={() => {
            setCheck(index);
          }}
        >
          {item.buttonText[lang]}
        </a>
      ))}
    </div>
  );
}

export default index;
